import { createBrowserRouter } from 'react-router'
import { CockpitPage } from '@/features/cockpit/CockpitPage'
import { MonitoringPage } from '@/features/monitoring/MonitoringPage'
import { ResourcesPage } from '@/features/resources/ResourcesPage'
import { AppLayout } from './AppLayout'

export const router = createBrowserRouter([
  {
    path: '/',
    Component: AppLayout,
    children: [
      { index: true, Component: CockpitPage },
      { path: 'monitoring', Component: MonitoringPage },
      { path: 'resources', Component: ResourcesPage },
    ],
  },
])
